import { install } from 'resize-observer'

// Polyfill for iOS < 13
if (!Promise.allSettled) {
    Promise.allSettled = promises => Promise.all(
        promises.map((promise) => promise
            .then(value => ({
                status: 'fulfilled',
                value
            }))
            .catch(reason => ({
                status: 'rejected',
                reason
            })))
    )
}

if (!window.ResizeObserver) {
    install()
}

if (![].at) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.at = function at(n) {
        let i = Math.trunc(n) || 0
        if (i < 0) i += this.length
        if (i < 0 || i >= this.length) return undefined
        return this[i]
    }
}

if (![].toReversed) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.toReversed = function toReversed() {
        if (this.length < 2) return Array.from(this)
        const arr = Array.from(this)
        arr.reverse()
        return arr
    }
}

if (![].toSorted) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.toSorted = function toSorted(compareFn) {
        const arr = Array.from(this)
        arr.sort(compareFn)
        return arr
    }
}

// eslint-disable-next-line no-extend-native
String.prototype.capitalize = function capitalize() {
    if (this.length === 0) return ''
    return this.charAt(0).toUpperCase() + this.slice(1)
}
